import QuitaCreate from './QuitaCreate'
export {QuitaCreate}
export default QuitaCreate
